var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 6",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6l6-6H0z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--caret-2cb2d25c85dd9730b846d34709383a4b.svg";
export { SvgIconUiCaret as Component };